import './style.scss'

const ready = () => {
  // cache menu, open button, and close button nodes
  const nodes = {
    menu: document.querySelector('.wz-menu'),
    open: document.querySelector('.wz-nav-switch'),
    close: document.querySelector('.wz-menu-switch')
  }

  // define event handlers
  const handleOpen = event => {
    event.preventDefault()
    window.requestAnimationFrame(() => nodes.menu.classList.add('is-active'))
  }

  const handleClose = event => {
    event.preventDefault()
    window.requestAnimationFrame(() => nodes.menu.classList.remove('is-active'))
  }

  // bind click events
  nodes.open && nodes.open.addEventListener('click', handleOpen)
  nodes.close && nodes.close.addEventListener('click', handleClose)
}

export function initialize() {
  ready()
}
